import type { ReactNode } from 'react'

export function Field({
  label,
  hint,
  children,
}: {
  label?: string
  hint?: ReactNode
  children: ReactNode
}) {
  return (
    <div className="block">
      {label ? <div className="text-label uppercase text-text-secondary">{label}</div> : null}
      <div className={label ? 'mt-2' : ''}>{children}</div>
      {hint ? <div className="mt-2 text-hint text-text-muted">{hint}</div> : null}
    </div>
  )
}

export const fieldShell =
  'w-full rounded-nested border border-hairline bg-field text-body text-text ' +
  'outline-hidden transition-[background-color,border-color,box-shadow] duration-row ' +
  'focus-within:border-accent focus-within:bg-field-focus focus-within:shadow-focus'

export const choiceRow =
  'pressable flex min-h-field w-full items-center gap-[11px] rounded-nested border px-[14px] ' +
  'text-left text-body transition-colors duration-row'

export function choiceTone(selected: boolean): string {
  return selected ? 'border-accent bg-accent text-on-accent' : 'border-hairline bg-field text-text'
}
